import { jsx as _jsx } from "react/jsx-runtime";
import { useRecordContext } from "react-admin";
import { useEventZonedFormat, useZonedFormat } from "@/hooks/useZonedFormat";
/**
 * An Admin Portal time as one value with a label ("09 Apr 2028, 03:41:15
 * PhST"): in the election event's primary zone, else the browser's.
 */
export var AdminDateTime = function (_a) {
    var value = _a.value, event = _a.event, seconds = _a.seconds, _b = _a.emptyText, emptyText = _b === void 0 ? "" : _b;
    var format = useEventZonedFormat(event, { seconds: seconds });
    return _jsx("span", { className: "admin-date-time", children: format.format(value) || emptyText });
};
/** The same in a zone the caller already knows (a server-given zone, a row's zone). */
export var ZonedDateTimeText = function (_a) {
    var value = _a.value, zone = _a.zone, seconds = _a.seconds;
    var format = useZonedFormat(zone, { seconds: seconds });
    return _jsx("span", { className: "admin-date-time", children: format.format(value) });
};
/** A react-admin field: the record's `source` time with its label. */
export var AdminDateField = function (_a) {
    var source = _a.source, event = _a.event, seconds = _a.seconds, emptyText = _a.emptyText;
    var record = useRecordContext();
    return (_jsx(AdminDateTime, { value: record === null || record === void 0 ? void 0 : record[source], event: event !== null && event !== void 0 ? event : record === null || record === void 0 ? void 0 : record.election_event_id, seconds: seconds, emptyText: emptyText }));
};
